// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__Xsx1p","products":"Search_products__w2jQY","header":"Search_header__4PRf8","goBack":"Search_goBack__i4iP+","title":"Search_title__R4nO7"};